
// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   Avatar,
//   Button,
//   useMediaQuery,
//   CircularProgress,
//   Modal,
//   IconButton,
//   Snackbar,
//   Alert,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   InputAdornment
// } from '@mui/material';
// import { useSelector } from 'react-redux';
// import { useNavigate, useParams, useLocation } from 'react-router-dom';
// import CloseIcon from '@mui/icons-material/Close';
// import PlayArrowIcon from '@mui/icons-material/PlayArrow';
// import FavoriteIcon from '@mui/icons-material/Favorite';
// import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
// import ShareIcon from '@mui/icons-material/Share';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';

// // Images
// import avatarIcon from '../../../assets/prof.png';
// import locationIcon from '../../../assets/loc.png';
// import calendarIcon from '../../../assets/calendar.png';
// import viewsIcon from '../../../assets/eye.png';
// import saveIcon from '../../../assets/logsave.png';
// import shareIcon from '../../../assets/logshare.png';
// import youtubeIcon from '../../../assets/logicon.png';
// import contactim from '../../../assets/conta.png';
// import similarImg from '../../../assets/sideimg.jpg';

// // Import Material UI icons for amenities
// import BedIcon from '@mui/icons-material/Bed';
// import BathtubIcon from '@mui/icons-material/Bathtub';
// import SquareFootIcon from '@mui/icons-material/SquareFoot';
// import ApartmentIcon from '@mui/icons-material/Apartment';
// import ElevatorIcon from '@mui/icons-material/Elevator';
// import LocalParkingIcon from '@mui/icons-material/LocalParking';
// import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
// import PoolIcon from '@mui/icons-material/Pool';
// import PetsIcon from '@mui/icons-material/Pets';
// import AcUnitIcon from '@mui/icons-material/AcUnit';
// import TvIcon from '@mui/icons-material/Tv';
// import ChairIcon from '@mui/icons-material/Chair';
// import KitchenIcon from '@mui/icons-material/Kitchen';
// import WeekendIcon from '@mui/icons-material/Weekend';
// import WifiIcon from '@mui/icons-material/Wifi';
// import LocalLaundryServiceIcon from '@mui/icons-material/LocalLaundryService';
// import MicrowaveIcon from '@mui/icons-material/Microwave';
// import PowerIcon from '@mui/icons-material/Power';
// import SecurityIcon from '@mui/icons-material/Security';
// import SportsBaseballIcon from '@mui/icons-material/SportsBaseball';
// import ChildCareIcon from '@mui/icons-material/ChildCare';
// import HouseIcon from '@mui/icons-material/House';
// import ParkIcon from '@mui/icons-material/Park';
// import LocationOnIcon from '@mui/icons-material/LocationOn';

// // Import the CreateInquiry component
// import CreateInquiry from './CreateInquiry';

// const TalkView = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { propertyId } = useParams();
//   const isMobile = useMediaQuery('(max-width:768px)');
//   const user = useSelector((state) => state.user.user);
//   const isLoggedIn = !!user?.token;
//   const propertyIds = useSelector((state) => state.user.properties);

//   // ✅ NEW: Check if viewing as shared (without login context)
//   const isSharedView = location.search.includes('shared=true');

//   const [property, setProperty] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [propertyMedia, setPropertyMedia] = useState([]);
//   const [selectedMediaIndex, setSelectedMediaIndex] = useState(0);
//   const [modalOpen, setModalOpen] = useState(false);

//   // State for similar properties
//   const [similarProperties, setSimilarProperties] = useState([]);
//   const [loadingSimilar, setLoadingSimilar] = useState(false);

//   // State for inquiry dialog
//   const [inquiryDialog, setInquiryDialog] = useState({
//     open: false,
//     propertyId: propertyId ? parseInt(propertyId) : null,
//     propertyTitle: ''
//   });

//   // State for favorite status and toast notifications
//   const [isFavorite, setIsFavorite] = useState(false);
//   const [toast, setToast] = useState({
//     open: false,
//     message: '',
//     severity: 'success'
//   });

//   // ✅ State for share dialog
//   const [shareDialog, setShareDialog] = useState(false);
//   const [shareUrl, setShareUrl] = useState('');

//   // ✅ Helper function to check if a value exists and is not empty
//   const hasValue = (value) => {
//     if (value === null || value === undefined) return false;
//     if (typeof value === 'string') {
//       const trimmed = value.trim();
//       return trimmed !== '' && trimmed !== 'null' && trimmed !== 'undefined' && trimmed !== 'N/A';
//     }
//     if (typeof value === 'number') return !isNaN(value);
//     return true;
//   };

//   // ✅ Function to get full furnishing type name
//   const getFurnishingTypeName = (furnishType) => {
//     if (!furnishType) return '';
//     const furnishingMap = {
//       'un': 'Unfurnished',
//       'unfurnished': 'Unfurnished',
//       'semi': 'Semi-Furnished',
//       'semi-furnished': 'Semi-Furnished',
//       'full': 'Fully Furnished',
//       'fully': 'Fully Furnished',
//       'fully-furnished': 'Fully Furnished'
//     };
//     const lowerType = furnishType.toLowerCase().trim();
//     return furnishingMap[lowerType] || furnishType.replace(/-/g, ' ');
//   };

//   // Function to get the appropriate icon component based on amenity type
//   const getAmenityIcon = (amenityType) => {
//     const amenityIconMap = {
//       'Lift': ElevatorIcon,
//       'Parking': LocalParkingIcon,
//       'Gym': FitnessCenterIcon,
//       'Swimming Pool': PoolIcon,
//       'Pet Allowed': PetsIcon,
//       'AC': AcUnitIcon,
//       'TV': TvIcon,
//       'Sofa': ChairIcon,
//       'Fridge': KitchenIcon,
//       'Furnished': WeekendIcon,
//       'Internet': WifiIcon,
//       'Washing Machine': LocalLaundryServiceIcon,
//       'Microwave': MicrowaveIcon,
//       'Power Backup': PowerIcon,
//       'Security': SecurityIcon,
//       'Sports': SportsBaseballIcon,
//       'Children Area': ChildCareIcon,
//       'Club House': HouseIcon,
//       'Garden': ParkIcon,
//       'Modular Kitchen': KitchenIcon,
//       'BHK': BedIcon,
//       'Floor': ApartmentIcon,
//       'Size': SquareFootIcon,
//       'Bathroom': BathtubIcon,
//       'Facilities Distance': LocationOnIcon
//     };
//     const IconComponent = amenityIconMap[amenityType] || SquareFootIcon;
//     return <IconComponent sx={{ color: '#666', fontSize: 24 }} />;
//   };

//   // Function to handle base64 images and videos
//   const processMedia = (propertyData) => {
//     const media = [];
//     if (propertyData.images && Array.isArray(propertyData.images)) {
//       propertyData.images.forEach((img, index) => {
//         if (img.image) {
//           const dataUrl = `data:image/jpeg;base64,${img.image}`;
//           media.push({
//             type: 'image',
//             src: dataUrl,
//             name: `property-image-${index + 1}`,
//             thumbnail: dataUrl
//           });
//         }
//         if (img.video_name) {
//           media.push({
//             type: 'video',
//             src: `https://propertydealstalk.com/uploads/videos/${img.video_name}`,
//             name: img.video_name,
//             thumbnail: youtubeIcon
//           });
//         }
//       });
//     }
//     return media;
//   };

//   // Fetch property details when component mounts or propertyId changes
//   useEffect(() => {
//     setLoading(true);
//     setError(null);
//     setProperty(null);
//     setPropertyMedia([]);
//     setSelectedMediaIndex(0);

//     const fetchPropertyDetails = async () => {
//       try {
//         const apiUrl = propertyId
//           ? `https://propertydealstalk.com/api/property/getProperties?property_id=${propertyId}`
//           : 'https://propertydealstalk.com/api/property/getProperties';

//         const response = await fetch(apiUrl);
//         if (!response.ok) {
//           throw new Error('Failed to fetch property details');
//         }

//         const data = await response.json();
//         if (data.statusCode === 200) {
//           const propertyList = Array.isArray(data.result) ? data.result : [data.result];
//           let selectedProperty;

//           if (propertyId) {
//             selectedProperty = Array.isArray(propertyList)
//               ? propertyList.find(p => p && p.id === parseInt(propertyId))
//               : propertyList;
//             if (!selectedProperty && propertyList.length > 0) {
//               selectedProperty = propertyList[0];
//             }
//           } else if (propertyList.length > 0) {
//              selectedProperty = propertyList[0];
//           }

//           if (selectedProperty) {
//             setProperty(selectedProperty);
//             const processedMedia = processMedia(selectedProperty);
//             setPropertyMedia(processedMedia);
//             setInquiryDialog(prev => ({
//               ...prev,
//               propertyId: selectedProperty.id,
//               propertyTitle: selectedProperty.property_name
//             }));
//             fetchSimilarProperties(selectedProperty.id);

//             // ✅ FIXED: Check favorite status after fetching property
//             if (isLoggedIn && user?.id && !isSharedView) {
//               checkFavoriteStatus(selectedProperty.id);
//             }
//           } else {
//             throw new Error('Property not found');
//           }
//         } else {
//           throw new Error(data.message || 'Failed to fetch property details');
//         }
//       } catch (err) {
//         setError(err.message);
//         console.error('Error fetching property:', err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPropertyDetails();
//   }, [propertyId, isLoggedIn, user?.id, isSharedView]);

//   // ✅ FIXED: Function to check if property is in favorites
//   const checkFavoriteStatus = async (propId) => {
//     if (!isLoggedIn || !user?.id) {
//       setIsFavorite(false);
//       return;
//     }

//     try {
//       const response = await fetch(`https://propertydealstalk.com/api/buyer/getFavorites?buyer_id=${user.id}`);
//       const data = await response.json();

//       if (data.statusCode === 200 && data.result) {
//         // Check if current property is in favorites
//         const favorites = Array.isArray(data.result) ? data.result : [];
//         const isInFavorites = favorites.some(fav => fav.property_id === propId || fav.id === propId);
//         setIsFavorite(isInFavorites);
//       } else {
//         setIsFavorite(false);
//       }
//     } catch (err) {
//       console.error('Error checking favorite status:', err);
//       setIsFavorite(false);
//     }
//   };

//   // ✅ FIXED: Function to toggle favorite status
//   const toggleFavorite = async () => {
//     if (!isLoggedIn) {
//       navigate('/login');
//       return;
//     }

//     try {
//       const response = await fetch('https://propertydealstalk.com/api/buyer/addFavorites', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${user?.token}`
//         },
//         body: JSON.stringify({
//           buyer_id: user?.id,
//           property_id: property?.id || propertyId
//         })
//       });

//       const data = await response.json();
//       if (data.statusCode === 200) {
//         setIsFavorite(true);
//         setToast({
//           open: true,
//           message: 'Property added to favorites successfully',
//           severity: 'success'
//         });
//       } else {
//         throw new Error(data.message || 'Failed to add property to favorites');
//       }
//     } catch (err) {
//       console.error('Error toggling favorite:', err);
//       setToast({
//         open: true,
//         message: err.message || 'Failed to update favorites',
//         severity: 'error'
//       });
//     }
//   };

//   // ✅ UPDATED: Function to handle share button click - adds shared=true parameter
//   const handleShareClick = () => {
//     // Generate the shareable URL (public view without login) with shared parameter
//     const publicUrl = `${window.location.origin}/view/${property?.id || propertyId}?shared=true`;
//     setShareUrl(publicUrl);
//     setShareDialog(true);
//   };

//   // ✅ Function to copy URL to clipboard
//   const handleCopyUrl = async () => {
//     try {
//       await navigator.clipboard.writeText(shareUrl);
//       setToast({
//         open: true,
//         message: 'URL copied to clipboard!',
//         severity: 'success'
//       });
//     } catch (err) {
//       console.error('Failed to copy URL:', err);
//       setToast({
//         open: true,
//         message: 'Failed to copy URL',
//         severity: 'error'
//       });
//     }
//   };

//   // ✅ Function to close share dialog
//   const handleCloseShareDialog = () => {
//     setShareDialog(false);
//   };

//   // Function to close toast notification
//   const handleCloseToast = (event, reason) => {
//     if (reason === 'clickaway') {
//       return;
//     }
//     setToast(prev => ({ ...prev, open: false }));
//   };

//   // Function to fetch similar properties
//   const fetchSimilarProperties = async (propId) => {
//     if (!propId) return;
//     setLoadingSimilar(true);

//     try {
//       const response = await fetch(`https://propertydealstalk.com/api/property/getSimilarProperties?property_id=${propId}`);
//       if (!response.ok) {
//         throw new Error('Failed to fetch similar properties');
//       }

//       const data = await response.json();
//       if (data.statusCode === 200 && data.result && data.result.similar_properties) {
//         setSimilarProperties(data.result.similar_properties.slice(0, 5));
//       } else {
//         console.warn('No similar properties found or invalid response format');
//         setSimilarProperties([]);
//       }
//     } catch (err) {
//       console.error('Error fetching similar properties:', err);
//       setSimilarProperties([]);
//     } finally {
//       setLoadingSimilar(false);
//     }
//   };

//   // Function to handle similar property click
//   const handleSimilarPropertyClick = (propertyId) => {
//     // ✅ UPDATED: Preserve shared parameter when navigating to similar properties
//     const sharedParam = isSharedView ? '?shared=true' : '';
//     window.history.pushState({}, '', `/view/${propertyId}${sharedParam}`);
//     setLoading(true);
//     setError(null);
//     setProperty(null);
//     setPropertyMedia([]);
//     setSelectedMediaIndex(0);
//     setSimilarProperties([]);

//     const fetchPropertyDetails = async () => {
//       try {
//         const apiUrl = `https://propertydealstalk.com/api/property/getProperties?property_id=${propertyId}`;
//         const response = await fetch(apiUrl);
//         if (!response.ok) {
//           throw new Error('Failed to fetch property details');
//         }

//         const data = await response.json();
//         if (data.statusCode === 200) {
//           const propertyList = Array.isArray(data.result) ? data.result : [data.result];
//           let selectedProperty;

//           selectedProperty = Array.isArray(propertyList)
//             ? propertyList.find(p => p && p.id === parseInt(propertyId))
//             : propertyList;
//           if (!selectedProperty && propertyList.length > 0) {
//              selectedProperty = propertyList[0];
//           }

//           if (selectedProperty) {
//             setProperty(selectedProperty);
//             const processedMedia = processMedia(selectedProperty);
//             setPropertyMedia(processedMedia);
//             setInquiryDialog(prev => ({
//               ...prev,
//               propertyId: selectedProperty.id,
//               propertyTitle: selectedProperty.property_name
//             }));
//             fetchSimilarProperties(selectedProperty.id);
//             if (isLoggedIn && !isSharedView) {
//               checkFavoriteStatus(selectedProperty.id);
//             }
//           } else {
//             throw new Error('Property not found');
//           }
//         } else {
//           throw new Error(data.message || 'Failed to fetch property details');
//         }
//       } catch (err) {
//         setError(err.message);
//         console.error('Error fetching property:', err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPropertyDetails();
//     window.scrollTo(0, 0);
//   };

//   // Function to handle opening the inquiry dialog
//   const handleOpenInquiry = () => {
//     if (!isLoggedIn) {
//       navigate('/login');
//       return;
//     }
//     setInquiryDialog(prev => ({
//       ...prev,
//       open: true
//     }));
//   };

//   // Function to handle closing the inquiry dialog
//   const handleCloseInquiry = () => {
//     setInquiryDialog(prev => ({
//       ...prev,
//       open: false
//     }));
//   };

//   // Function to handle media selection
//   const handleMediaSelect = (index) => {
//     setSelectedMediaIndex(index);
//   };

//   // Function to open modal with selected media
//   const handleOpenModal = (index) => {
//     setSelectedMediaIndex(index);
//     setModalOpen(true);
//   };

//   // Function to close modal
//   const handleCloseModal = () => {
//     setModalOpen(false);
//   };

//   // Function to navigate media in modal
//   const handleModalNavigation = (direction) => {
//     if (direction === 'next') {
//       setSelectedMediaIndex((prev) => (prev + 1) % propertyMedia.length);
//     } else {
//       setSelectedMediaIndex((prev) => (prev - 1 + propertyMedia.length) % propertyMedia.length);
//     }
//   };

//   // Function to format price with commas
//   const formatPrice = (price) => {
//     return price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || '';
//   };

//   // Parse amenities from property data
//   const parseAmenities = (property) => {
//     if (!property) return [];
//     const amenitiesList = [];

//     if (property.society_aminities) {
//       const societyAmenities = property.society_aminities.split(',').map(item => item.trim());
//       amenitiesList.push(...societyAmenities);
//     }

//     if (property.furnish_facilities) {
//       const furnishFacilities = property.furnish_facilities.split(',').map(item => item.trim());
//       amenitiesList.push(...furnishFacilities);
//     }

//     if (property.other_facilities) {
//       const otherFacilities = property.other_facilities.split(',').map(item => item.trim());
//       amenitiesList.push(...otherFacilities);
//     }

//     return [...new Set(amenitiesList)];
//   };

//   // If still loading, show loading spinner
//   if (loading || !property) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   // ✅ Get all amenities
//   const allAmenities = parseAmenities(property);

//   // ✅ Function to determine if amenities should be shown based on property type
//   const shouldShowAmenities = () => {
//     const residentialTypes = ['Apartment', 'House', 'Villa', 'Residential'];
//     return residentialTypes.some(type =>
//       property.asset_type?.includes(type) || property.property_type?.includes(type)
//     );
//   };

//   // Calculate built year from age_of_property
//   const builtYear = property.age_of_property
//     ? (new Date().getFullYear() - property.age_of_property)
//     : 'Not specified';

//   // ✅ Get property details for the top section - ONLY show if values exist
//   const getPropertyDetails = () => {
//     const details = [];

//     if (hasValue(property.bhk)) {
//       details.push({ type: 'BHK', value: `${property.bhk} BHK` });
//     }

//     if (hasValue(property.select_floor) && hasValue(property.total_floors)) {
//       details.push({ type: 'Floor', value: `${property.select_floor}/${property.total_floors} Floor` });
//     }

//     if (hasValue(property.property_size)) {
//       const sizeUnit = hasValue(property.property_size_units) ? property.property_size_units : 'sq.ft';
//       details.push({ type: 'Size', value: `${property.property_size} ${sizeUnit}` });
//     }

//     return details;
//   };

//   const propertyDetails = getPropertyDetails();

//   // ✅ FIXED: Determine the price to display with better logic
//   const getDisplayPrice = () => {
//     // Check if it's a rental property (case-insensitive comparison)
//     const category = property.category || property.commercial_catgory || '';
//     const isRental = category.toLowerCase() === 'rent';

//     if (isRental) {
//       // For rental properties, prioritize monthly_rent
//       if (hasValue(property.monthly_rent) && property.monthly_rent !== 0) {
//         return property.monthly_rent;
//       }
//     }

//     // For sale properties or if monthly_rent is not available, use asking_price
//     if (hasValue(property.asking_price) && property.asking_price !== 0) {
//       return property.asking_price;
//     }

//     return null; // Return null if no price is available
//   };

//   const displayPrice = getDisplayPrice();
//   const isRentalProperty = (property.category || property.commercial_catgory || '').toLowerCase() === 'rent';

//   // ✅ NEW: Determine if contact info should be shown (hide for shared views)
//   const shouldShowContactInfo = isLoggedIn && !isSharedView;

//   return (
//     <Box
//       sx={{
//         background: '#f9f9f9',
//         fontFamily: 'Outfit, sans-serif',
//         px: isMobile ? 2 : 6,
//         py: isMobile ? 2 : 4,
//       }}
//     >
//       <Box
//         sx={{
//           display: 'flex',
//           flexDirection: isMobile ? 'column' : 'row',
//           gap: isMobile ? 3 : 4,
//         }}
//       >
//         {/* LEFT SECTION */}
//         <Box sx={{ flex: 1 }}>
//           {/* Main Media Display */}
//           <Box sx={{ position: 'relative', width: '100%', height: isMobile ? 250 : 450 }}>
//             {propertyMedia.length > 0 ? (
//               <>
//                 {propertyMedia[selectedMediaIndex].type === 'image' ? (
//                   <Box
//                     component="img"
//                     src={propertyMedia[selectedMediaIndex].src}
//                     alt={property.property_name}
//                     sx={{
//                       width: '100%',
//                       height: '100%',
//                       objectFit: 'cover',
//                       borderRadius: 2,
//                       cursor: 'pointer'
//                     }}
//                     onClick={() => handleOpenModal(selectedMediaIndex)}
//                   />
//                 ) : (
//                   <Box
//                     sx={{
//                       width: '100%',
//                       height: '100%',
//                       bgcolor: '#000',
//                       borderRadius: 2,
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       cursor: 'pointer',
//                       position: 'relative'
//                     }}
//                     onClick={() => handleOpenModal(selectedMediaIndex)}
//                   >
//                     <video
//                       src={propertyMedia[selectedMediaIndex].src}
//                       style={{
//                         width: '100%',
//                         height: '100%',
//                         objectFit: 'cover',
//                         borderRadius: 2
//                       }}
//                     />
//                     <PlayArrowIcon
//                       sx={{
//                         position: 'absolute',
//                         color: 'white',
//                         fontSize: 60,
//                         opacity: 0.8
//                       }}
//                     />
//                   </Box>
//                 )}
//               </>
//             ) : (
//               <Box
//                 sx={{
//                   width: '100%',
//                   height: '100%',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   backgroundColor: '#f5f5f5',
//                   borderRadius: 2,
//                   border: '1px dashed #ccc'
//                 }}
//               >
//                 <Typography variant="h6" color="#888" textAlign="center">
//                   No images uploaded
//                 </Typography>
//               </Box>
//             )}

//             {/* Media counter */}
//             {propertyMedia.length > 1 && (
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   top: 16,
//                   right: 16,
//                   bgcolor: 'rgba(0,0,0,0.7)',
//                   color: 'white',
//                   padding: '4px 12px',
//                   borderRadius: 2,
//                   fontSize: 14
//                 }}
//               >
//                 {selectedMediaIndex + 1} / {propertyMedia.length}
//               </Box>
//             )}

//             {/* Navigation arrows for media */}
//             {propertyMedia.length > 1 && (
//               <>
//                 <IconButton
//                   sx={{
//                     position: 'absolute',
//                     left: 16,
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     bgcolor: 'rgba(255,255,255,0.9)',
//                     '&:hover': { bgcolor: 'rgba(255,255,255,1)' }
//                   }}
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     handleMediaSelect((selectedMediaIndex - 1 + propertyMedia.length) % propertyMedia.length);
//                   }}
//                 >
//                   <Typography variant="h6" sx={{ color: '#000' }}>‹</Typography>
//                 </IconButton>
//                 <IconButton
//                   sx={{
//                     position: 'absolute',
//                     right: 16,
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     bgcolor: 'rgba(255,255,255,0.9)',
//                     '&:hover': { bgcolor: 'rgba(255,255,255,1)' }
//                   }}
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     handleMediaSelect((selectedMediaIndex + 1) % propertyMedia.length);
//                   }}
//                 >
//                   <Typography variant="h6" sx={{ color: '#000' }}>›</Typography>
//                 </IconButton>
//               </>
//             )}
//           </Box>

//           {/* Media Thumbnails Gallery */}
//           {propertyMedia.length > 1 && (
//             <Box
//               sx={{
//                 display: 'flex',
//                 gap: 2,
//                 mt: 2,
//                 overflowX: 'auto',
//                 pb: 1,
//                 '&::-webkit-scrollbar': {
//                   height: 4,
//                 },
//                 '&::-webkit-scrollbar-track': {
//                   background: '#f1f1f1',
//                 },
//                 '&::-webkit-scrollbar-thumb': {
//                   background: '#888',
//                   borderRadius: 2,
//                 },
//               }}
//             >
//               {propertyMedia.map((media, index) => (
//                 <Box
//                   key={index}
//                   sx={{
//                     position: 'relative',
//                     minWidth: 80,
//                     height: 80,
//                     borderRadius: 2,
//                     overflow: 'hidden',
//                     cursor: 'pointer',
//                     border: selectedMediaIndex === index ? '3px solid #2563EB' : '2px solid #ddd',
//                     opacity: selectedMediaIndex === index ? 1 : 0.7,
//                     transition: 'all 0.2s ease',
//                     '&:hover': {
//                       opacity: 1,
//                       transform: 'scale(1.05)'
//                     }
//                   }}
//                   onClick={() => handleMediaSelect(index)}
//                 >
//                   {media.type === 'image' ? (
//                     <Box
//                       component="img"
//                       src={media.src}
//                       alt={`Thumbnail ${index + 1}`}
//                       sx={{
//                         width: '100%',
//                         height: '100%',
//                         objectFit: 'cover'
//                       }}
//                     />
//                   ) : (
//                     <Box
//                       sx={{
//                         width: '100%',
//                         height: '100%',
//                         bgcolor: '#000',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center'
//                       }}
//                     >
//                       <PlayArrowIcon sx={{ color: 'white', fontSize: 24 }} />
//                     </Box>
//                   )}
//                   {media.type === 'video' && (
//                     <Box
//                       sx={{
//                         position: 'absolute',
//                         top: 4,
//                         right: 4,
//                         bgcolor: 'rgba(0,0,0,0.7)',
//                         borderRadius: '50%',
//                         width: 20,
//                         height: 20,
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center'
//                       }}
//                     >
//                       <PlayArrowIcon sx={{ color: 'white', fontSize: 12 }} />
//                                        </Box>
//                   )}
//                 </Box>
//               ))}
//             </Box>
//           )}

//           {/* Description Box */}
//           <Box mt={4} bgcolor="#fff" p={3} borderRadius={2}>
//             {/* ✅ Property Description - Show only if it has value */}
//             {hasValue(property.description) && (
//               <>
//                 <Typography variant="h6" mb={2}>Property Description</Typography>
//                 <Typography fontSize={14} color="#626262" mb={2}>
//                   {property.description}
//                 </Typography>
//               </>
//             )}

//             {/* ✅ Content Section - Show only if it has value (for commercial plots) */}
//             {hasValue(property.content) && (
//               <>
//                 <Typography variant="h6" mb={2} mt={hasValue(property.description) ? 3 : 0}>
//                   Additional Content
//                 </Typography>
//                 <Typography fontSize={14} color="#626262" mb={2}>
//                   {property.content}
//                 </Typography>
//               </>
//             )}

//             {/* ✅ Complete Address - Show only if it has value */}
//             {hasValue(property.full_address) && (
//               <>
//                 <Typography variant="h6" mb={2} mt={3}>Complete Address</Typography>
//                 <Typography fontSize={14} color="#626262" mb={2}>
//                   {property.full_address}
//                 </Typography>
//               </>
//             )}

//             {/* ✅ Features & Amenities - Only show for applicable property types */}
//             {shouldShowAmenities() && allAmenities.length > 0 && (
//               <>
//                 <Typography variant="subtitle1" mb={2} mt={3} fontWeight={500}>
//                   Features & Amenities
//                 </Typography>
//                 <Box
//                   sx={{
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
//                     columnGap: 4,
//                     rowGap: 2,
//                   }}
//                 >
//                   {allAmenities.map((amenity, index) => (
//                     <Box key={index} display="flex" alignItems="center" gap={1} fontSize={14} fontWeight="bold">
//                       {getAmenityIcon(amenity)}
//                       {amenity}
//                     </Box>
//                   ))}
//                 </Box>
//               </>
//             )}

//             {/* ✅ Carpet Area & Built-up Area - Only for Apartments */}
//             {property.asset_type === 'Apartment' && (hasValue(property.carpet_area) || hasValue(property.built_up_area) || hasValue(property.uds)) && (
//               <>
//                 <Typography variant="subtitle1" mt={3} mb={2} fontWeight={500}>
//                   Area Details
//                 </Typography>
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     flexDirection: isMobile ? 'column' : 'row',
//                     gap: 2,
//                   }}
//                 >
//                   {hasValue(property.carpet_area) && (
//                     <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262" flex={1}>
//                       <Box minWidth={130}>Carpet Area</Box>
//                       <Box fontWeight="bold">
//                         {property.carpet_area} {property.carpet_area_units}
//                       </Box>
//                     </Box>
//                   )}
//                   {hasValue(property.built_up_area) && (
//                     <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262" flex={1}>
//                       <Box minWidth={130}>Built-up Area</Box>
//                       <Box fontWeight="bold">
//                         {property.built_up_area} {property.built_up_area_units}
//                       </Box>
//                     </Box>
//                   )}
//                 </Box>
//                 {/* ✅ UDS Field - FIXED: Use 'uds' instead of 'uds_area' */}
//                 {hasValue(property.uds) && (
//                   <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262" mt={1}>
//                     <Box minWidth={130}>UDS (Undivided Share)</Box>
//                     <Box fontWeight="bold">
//                       {property.uds} {property.uds_units || 'Sq.Ft'}
//                     </Box>
//                   </Box>
//                 )}
//               </>
//             )}

//             {/* ✅ Additional Details Section - Show only fields with values */}
//             <Typography variant="subtitle1" mt={3} fontWeight={500}>Additional Details</Typography>
//             <Box mt={1}>
//               {/* Property Type - Always show */}
//               <Box
//                 display="flex"
//                 flexWrap="wrap"
//                 alignItems="center"
//                 gap={isMobile ? 1 : 3}
//                 mb={1}
//                 fontSize={14}
//                 color="#626262"
//                 fontWeight={400}
//               >
//                 <Box minWidth={130}>Property Type</Box>
//                 <Box fontWeight="bold">{property.property_type} {property.asset_type}</Box>
//               </Box>

//               {/* Property ID - Always show */}
//               <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//                 <Box minWidth={130}>Property ID</Box>
//                 <Box fontWeight="bold">#{property.id}</Box>
//               </Box>

//               {/* ✅ Price Negotiable */}
//               {hasValue(property.negotiable) && (
//                 <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//                   <Box minWidth={130}>Price Negotiable</Box>
//                   <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
//                     {property.negotiable === 'true' || property.negotiable === true ? 'Yes' : 'No'}
//                   </Box>
//                 </Box>
//               )}

//               {/* ✅ Total Floors - Show only if has value */}
//               {hasValue(property.total_floors) && (
//                 <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//                   <Box minWidth={130}>Total Floors</Box>
//                   <Box fontWeight="bold">{property.total_floors}</Box>
//                 </Box>
//               )}

//               {/* ✅ Floor Number - Show only if has value */}
//               {hasValue(property.select_floor) && (
//                 <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//                   <Box minWidth={130}>Floor Number</Box>
//                   <Box fontWeight="bold">{property.select_floor}</Box>
//                 </Box>
//               )}

//               {/* ✅ Furnishing - Show only if has value with FULL NAME */}
//               {hasValue(property.furnish_type) && (
//                 <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//                   <Box minWidth={130}>Furnishing</Box>
//                   <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
//                     {getFurnishingTypeName(property.furnish_type)}
//                   </Box>
//                 </Box>
//               )}

//               {/* ✅ Construction Status - Show only if has value */}
//               {hasValue(property.construction_status) && (
//                 <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//                   <Box minWidth={130}>Construction Status</Box>
//                   <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
//                     {property.construction_status}
//                   </Box>
//                 </Box>
//               )}

//               {/* ✅ Monthly Rent - Show only if has value */}
//               {hasValue(property.monthly_rent) && (
//                 <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//                   <Box minWidth={130}>Monthly Rent</Box>
//                   <Box fontWeight="bold">
//                     {property.currency}{formatPrice(property.monthly_rent)}
//                   </Box>
//                 </Box>
//               )}

//               {/* ✅ Security Deposit - Show only if has value */}
//               {hasValue(property.security_deposit) && (
//                 <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//                   <Box minWidth={130}>Security Deposit</Box>
//                   <Box fontWeight="bold">{property.security_deposit}</Box>
//                 </Box>
//               )}

//               {/* ✅ Available From - Show only if has value */}
//               {hasValue(property.available_from) && (
//                 <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//                   <Box minWidth={130}>Available From</Box>
//                   <Box fontWeight="bold">
//                     {new Date(property.available_from).toLocaleDateString('en-US', {
//                       month: 'long',
//                       day: 'numeric',
//                       year: 'numeric'
//                     })}
//                   </Box>
//                 </Box>
//               )}

//               {/* ✅ Length - Show only if has value */}
//               {hasValue(property.length) && (
//                 <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//                   <Box minWidth={130}>Length</Box>
//                   <Box fontWeight="bold">
//                     {property.length} {property.property_size_units}
//                   </Box>
//                 </Box>
//               )}

//               {/* ✅ Width - Show only if has value */}
//               {hasValue(property.width) && (
//                 <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//                   <Box minWidth={130}>Width</Box>
//                   <Box fontWeight="bold">
//                     {property.width} {property.property_size_units}
//                   </Box>
//                 </Box>
//               )}

//               {/* ✅ Ownership - Show only if has value */}
//               {hasValue(property.ownership) && (
//                 <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//                   <Box minWidth={130}>Ownership</Box>
//                   <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
//                     {property.ownership}
//                   </Box>
//                 </Box>
//               )}

//               {/* ✅ Hub - Show only if has value */}
//               {hasValue(property.hub) && (
//                 <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//                   <Box minWidth={130}>Hub</Box>
//                   <Box fontWeight="bold">{property.hub}</Box>
//                 </Box>
//               )}

//               {/* ✅ Commercial Category - Show only if has value */}
//               {hasValue(property.commercial_catgory) && (
//                 <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//                   <Box minWidth={130}>Category</Box>
//                   <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
//                     {property.commercial_catgory}
//                   </Box>
//                 </Box>
//               )}

//               {/* ✅ YouTube Link - Show only if has value */}
//               {hasValue(property.youtube_link) && property.youtube_link !== "null" && (
//                 <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//                   <Box minWidth={130}>YouTube Link</Box>
//                   <Box fontWeight="bold" sx={{ wordBreak: 'break-all' }}>
//                     {shouldShowContactInfo ? (
//                       <a
//                         href={property.youtube_link.trim()}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         style={{
//                           color: '#2563EB',
//                           textDecoration: 'underline',
//                           cursor: 'pointer'
//                         }}
//                       >
//                         {property.youtube_link.trim()}
//                       </a>
//                     ) : (
//                       <span style={{ color: '#2563EB' }}>https://youtu.be/****</span>
//                     )}
//                   </Box>
//                 </Box>
//               )}

//               {/* ✅ Property Video - Show only if video exists in media */}
//               {propertyMedia.some(media => media.type === 'video') && (
//                 <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//                   <Box minWidth={130}>Property Video</Box>
//                   <Box fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <img src={youtubeIcon} alt="Video" width={18} />
//                     Available
//                   </Box>
//                 </Box>
//               )}
//             </Box>
//           </Box>
//         </Box>

//         {/* RIGHT SECTION */}
//         <Box sx={{ flex: 1, maxWidth: isMobile ? '100%' : 420 }}>
//           <Box
//             bgcolor="#fff"
//             p={3}
//             borderRadius={2}
//             mb={3}
//             height={isMobile ? 'auto' : 'auto'}
//             display="flex"
//             flexDirection="column"
//           >
//             {/* ✅ UPDATED: Display monthly rent if it's a rental property, otherwise asking price */}
//             <Typography color="#2563EB" fontstyle="semibold" fontSize={22} fontWeight={600}>
//               {displayPrice && displayPrice !== 0 ? (
//                 <>
//                   {property.currency || '₹'}{formatPrice(displayPrice)}
//                   {isRentalProperty && ' /month'}
//                 </>
//               ) : (
//                 'Price on Request'
//               )}
//             </Typography>

//             <Typography fontSize={17} my={1.5} fontWeight={600}>
//               {property.property_name}
//             </Typography>

//             <Box display="flex" alignItems="center" gap={1} fontSize={14} fontWeight={400} color="#555" mb={1}>
//               <LocationOnIcon sx={{ fontSize: 16, color: '#666' }} />
//               {property.location}, {property.area_name}
//             </Box>

//             <Box display="flex" justifyContent="space-between" my={1} fontWeight={400} fontSize={13.5} color="#666">
//               <Box display="flex" alignItems="center" gap={1}>
//                 <img src={calendarIcon} alt="Calendar" width={16} height={17} />
//                 {new Date(property.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
//               </Box>
//             </Box>

//             {/* ✅ Property Details with Icons - Only show valid details */}
//             {propertyDetails.length > 0 && (
//               <Box display="flex" gap={isMobile ? 4 : 8} flexWrap="wrap" my={2} justifyContent="space-between">
//                 {propertyDetails.map((detail, index) => (
//                   <Box key={index} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                     <Box sx={{ color: '#666', fontSize: 30, height: 40, display: 'flex', alignItems: 'center' }}>
//                       {getAmenityIcon(detail.type)}
//                     </Box>
//                     <Typography fontSize={14}>{detail.value}</Typography>
//                   </Box>
//                 ))}
//               </Box>
//             )}

//             <hr style={{ margin: '8px 0', border: 'none', borderTop: '1px solid #eee' }} />

//             {/* ✅ UPDATED: Contact Seller Section - Hide contact info AND seller name for shared views */}
//             <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//               <Typography variant="subtitle1" fontSize={17} fontWeight={600} color="#000000">
//                 Contact Seller
//               </Typography>
//               {shouldShowContactInfo && (
//                 <Button
//                   variant="text"
//                   sx={{ p: 0, minWidth: 'auto' }}
//                   onClick={handleOpenInquiry}
//                 >
//                   <img src={contactim} alt="Contact" style={{ height: 40 }} />
//                 </Button>
//               )}
//             </Box>

//             <Box display="flex" alignItems="center" gap={3} mt={1}>
//               <Avatar
//                 src={property?.seller?.profile_image || avatarIcon}
//                 sx={{ width: 57, height: 62 }}
//               />
//               <Box>
//                 {/* ✅ UPDATED: Hide seller name when not logged in or in shared view */}
//                 <Typography fontSize={15} fontWeight={500} color="#000000">
//                   {shouldShowContactInfo
//                     ? (property?.seller?.full_name || "Seller")
//                     : "Seller"}
//                 </Typography>
//                 <Typography fontSize={13} color="blue" fontWeight={400}>
//                   {shouldShowContactInfo
//                     ? (property?.seller?.contact_number || "+91 123456789")
//                     : '+91 123*****89'}
//                 </Typography>
//                 <Typography fontSize={15} color="#000000" fontWeight={500}>
//                   {shouldShowContactInfo
//                     ? (property?.seller?.email_id || "seller@example.com")
//                     : 'Seller*****@gmail.com'}
//                 </Typography>
//               </Box>
//             </Box>

//             <hr style={{ margin: '12px 0', border: 'none', borderTop: '1px solid #eee' }} />

//             {/* ✅ UPDATED: Show Save and Share buttons only when logged in and not in shared view */}
//             {shouldShowContactInfo && (
//               <Box
//                 display="flex"
//                 gap={3}
//                 mt={2}
//                 alignItems="center"
//               >
//                 {/* Save Button */}
//                 <Box
//                   display="flex"
//                   alignItems="center"
//                   gap={1}
//                   sx={{ cursor: 'pointer' }}
//                   onClick={toggleFavorite}
//                 >
//                   {isFavorite ? (
//                     <FavoriteIcon sx={{ color: 'red', fontSize: 32 }} />
//                   ) : (
//                     <FavoriteBorderIcon sx={{ color: '#666', fontSize: 32 }} />
//                   )}
//                   <Typography fontSize={14} fontWeight={500} color="#000">
//                     Save
//                   </Typography>
//                 </Box>

//                 {/* ✅ Share Button with onClick handler */}
//                 <Box
//                   display="flex"
//                   alignItems="center"
//                   gap={1}
//                   sx={{ cursor: 'pointer' }}
//                   onClick={handleShareClick}
//                 >
//                   <ShareIcon sx={{ color: '#666', fontSize: 28 }} />
//                   <Typography fontSize={14} fontWeight={500} color="#000">
//                     Share
//                   </Typography>
//                 </Box>
//               </Box>
//             )}
//           </Box>

//           {/* Similar Properties */}
//           <Box bgcolor="#fff" p={3} borderRadius={2}>
//             <Typography variant="subtitle1" mb={2} fontWeight={600}>
//               Similar Properties
//             </Typography>
//             {loadingSimilar ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
//                 <CircularProgress size={24} />
//               </Box>
//             ) : similarProperties.length === 0 ? (
//               <Typography color="#666">No similar properties found.</Typography>
//             ) : (
//               similarProperties.map((sim) => {
//                 const simImageSrc = sim.image
//                   ? `data:image/png;base64,${sim.image}`
//                   : similarImg;

//                 return (
//                   <Box
//                     key={sim.id}
//                     display="flex"
//                     alignItems="center"
//                     gap={2}
//                     mb={2}
//                     sx={{
//                       cursor: 'pointer',
//                       transition: 'all 0.2s ease',
//                       '&:hover': {
//                         backgroundColor: '#f5f8ff',
//                         borderRadius: '8px'
//                       },
//                       p: 1
//                     }}
//                     onClick={() => handleSimilarPropertyClick(sim.id)}
//                   >
//                     <img
//                       src={simImageSrc}
//                       alt={sim.property_name || 'Similar Property'}
//                       width={60}
//                       height={60}
//                       style={{ borderRadius: 8, objectFit: 'cover' }}
//                     />
//                     <Box>
//                       <Typography fontSize={13} fontWeight={500}>
//                         {sim.property_name || `${sim.asset_type || ''} ${sim.property_type || ''}`}
//                       </Typography>
//                       <Typography fontSize={13} color="#2563EB" fontWeight={500}>
//                         {sim.currency || '₹'}
//                         {formatPrice(sim.asking_price)}
//                       </Typography>
//                       <Typography fontSize={12} color="#666">
//                         {sim.area_name ? `${sim.area_name}, ${sim.location}` : `${sim.location}`}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 );
//               })
//             )}
//           </Box>
//         </Box>
//       </Box>

//       {/* Media Modal */}
//       <Modal
//         open={modalOpen}
//         onClose={handleCloseModal}
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           backdropFilter: 'blur(5px)'
//         }}
//       >
//         <Box sx={{ position: 'relative', maxWidth: '90vw', maxHeight: '90vh' }}>
//           <IconButton
//             sx={{
//               position: 'absolute',
//               top: 8,
//               right: 8,
//               bgcolor: 'rgba(0,0,0,0.5)',
//               color: 'white',
//               zIndex: 1000,
//               '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
//             }}
//             onClick={handleCloseModal}
//           >
//             <CloseIcon />
//           </IconButton>

//           {propertyMedia.length > 1 && (
//             <>
//               <IconButton
//                 sx={{
//                   position: 'absolute',
//                   left: 8,
//                   top: '50%',
//                   transform: 'translateY(-50%)',
//                   bgcolor: 'rgba(0,0,0,0.5)',
//                   color: 'white',
//                   zIndex: 1000,
//                   '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
//                 }}
//                 onClick={() => handleModalNavigation('prev')}
//               >
//                 <Typography variant="h6">‹</Typography>
//               </IconButton>
//               <IconButton
//                 sx={{
//                   position: 'absolute',
//                   right: 8,
//                   top: '50%',
//                   transform: 'translateY(-50%)',
//                   bgcolor: 'rgba(0,0,0,0.5)',
//                   color: 'white',
//                   zIndex: 1000,
//                   '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
//                 }}
//                 onClick={() => handleModalNavigation('next')}
//               >
//                 <Typography variant="h6">›</Typography>
//               </IconButton>
//             </>
//           )}

//           {propertyMedia[selectedMediaIndex]?.type === 'image' ? (
//             <Box
//               component="img"
//               src={propertyMedia[selectedMediaIndex].src}
//               alt={property.property_name}
//               sx={{
//                 maxWidth: '100%',
//                 maxHeight: '90vh',
//                 objectFit: 'contain'
//               }}
//             />
//           ) : (
//             <Box
//               sx={{
//                 width: '80vw',
//                 height: '80vh',
//                 bgcolor: '#000'
//               }}
//             >
//               <video
//                 src={propertyMedia[selectedMediaIndex]?.src}
//                 controls
//                 autoPlay
//                 style={{
//                   width: '100%',
//                   height: '100%',
//                   objectFit: 'contain'
//                 }}
//               />
//             </Box>
//           )}
//         </Box>
//       </Modal>

//       {/* ✅ Share Dialog with URL Display and Copy Button */}
//       <Dialog
//         open={shareDialog}
//         onClose={handleCloseShareDialog}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//           <Typography variant="h6" fontWeight={600}>Share Property</Typography>
//           <IconButton onClick={handleCloseShareDialog} size="small">
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="#666" mb={2}>
//             Share this property link with others. Anyone with this link can view the property details.
//           </Typography>
//           <TextField
//             fullWidth
//             value={shareUrl}
//             InputProps={{
//               readOnly: true,
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton
//                     onClick={handleCopyUrl}
//                     edge="end"
//                     color="primary"
//                     title="Copy URL"
//                   >
//                     <ContentCopyIcon />
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             }}
//             variant="outlined"
//             sx={{
//               '& .MuiOutlinedInput-root': {
//                 backgroundColor: '#f5f5f5',
//               }
//             }}
//           />
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <Button onClick={handleCloseShareDialog} variant="outlined">
//             Close
//           </Button>
//           <Button onClick={handleCopyUrl} variant="contained" startIcon={<ContentCopyIcon />}>
//             Copy Link
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Toast Notification */}
//       <Snackbar
//         open={toast.open}
//         autoHideDuration={6000}
//         onClose={handleCloseToast}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert onClose={handleCloseToast} severity={toast.severity} sx={{ width: '100%' }}>
//           {toast.message}
//         </Alert>
//       </Snackbar>

//       {/* Inquiry Dialog */}
//       <CreateInquiry
//         open={inquiryDialog.open}
//         onClose={handleCloseInquiry}
//         propertyId={inquiryDialog.propertyId}
//         buyerId={user?.id || 1}
//         propertyTitle={inquiryDialog.propertyTitle}
//       />
//     </Box>
//   );
// };

// export default TalkView;


import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Avatar,
  Button,
  useMediaQuery,
  CircularProgress,
  Modal,
  IconButton,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputAdornment
} from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ShareIcon from '@mui/icons-material/Share';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

// Images
import avatarIcon from '../../../assets/prof.png';
import locationIcon from '../../../assets/loc.png';
import calendarIcon from '../../../assets/calendar.png';
import viewsIcon from '../../../assets/eye.png';
import saveIcon from '../../../assets/logsave.png';
import shareIcon from '../../../assets/logshare.png';
import youtubeIcon from '../../../assets/logicon.png';
import contactim from '../../../assets/conta.png';
import similarImg from '../../../assets/sideimg.jpg';

// Import Material UI icons for amenities
import BedIcon from '@mui/icons-material/Bed';
import BathtubIcon from '@mui/icons-material/Bathtub';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import ApartmentIcon from '@mui/icons-material/Apartment';
import ElevatorIcon from '@mui/icons-material/Elevator';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import PoolIcon from '@mui/icons-material/Pool';
import PetsIcon from '@mui/icons-material/Pets';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import TvIcon from '@mui/icons-material/Tv';
import ChairIcon from '@mui/icons-material/Chair';
import KitchenIcon from '@mui/icons-material/Kitchen';
import WeekendIcon from '@mui/icons-material/Weekend';
import WifiIcon from '@mui/icons-material/Wifi';
import LocalLaundryServiceIcon from '@mui/icons-material/LocalLaundryService';
import MicrowaveIcon from '@mui/icons-material/Microwave';
import PowerIcon from '@mui/icons-material/Power';
import SecurityIcon from '@mui/icons-material/Security';
import SportsBaseballIcon from '@mui/icons-material/SportsBaseball';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import HouseIcon from '@mui/icons-material/House';
import ParkIcon from '@mui/icons-material/Park';
import LocationOnIcon from '@mui/icons-material/LocationOn';

// Import the CreateInquiry component
import CreateInquiry from './CreateInquiry';

const TalkView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { propertyId } = useParams();
  const isMobile = useMediaQuery('(max-width:768px)');
  const user = useSelector((state) => state.user.user);
  const isLoggedIn = !!user?.token;
  const propertyIds = useSelector((state) => state.user.properties);

  // ✅ NEW: Check if viewing as shared (without login context)
  const isSharedView = location.search.includes('shared=true');

  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [propertyMedia, setPropertyMedia] = useState([]);
  const [selectedMediaIndex, setSelectedMediaIndex] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);

  // ✅ NEW: State for seller/admin details
  const [sellerDetails, setSellerDetails] = useState(null);

  // State for similar properties
  const [similarProperties, setSimilarProperties] = useState([]);
  const [loadingSimilar, setLoadingSimilar] = useState(false);

  // State for inquiry dialog
  const [inquiryDialog, setInquiryDialog] = useState({
    open: false,
    propertyId: propertyId ? parseInt(propertyId) : null,
    propertyTitle: ''
  });

  // State for favorite status and toast notifications
  const [isFavorite, setIsFavorite] = useState(false);
  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  // ✅ State for share dialog
  const [shareDialog, setShareDialog] = useState(false);
  const [shareUrl, setShareUrl] = useState('');

  // ✅ Helper function to check if a value exists and is not empty
  const hasValue = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string') {
      const trimmed = value.trim();
      return trimmed !== '' && trimmed !== 'null' && trimmed !== 'undefined' && trimmed !== 'N/A';
    }
    if (typeof value === 'number') return !isNaN(value);
    return true;
  };

  // ✅ Function to get full furnishing type name
  const getFurnishingTypeName = (furnishType) => {
    if (!furnishType) return '';
    const furnishingMap = {
      'un': 'Unfurnished',
      'unfurnished': 'Unfurnished',
      'semi': 'Semi-Furnished',
      'semi-furnished': 'Semi-Furnished',
      'full': 'Fully Furnished',
      'fully': 'Fully Furnished',
      'fully-furnished': 'Fully Furnished'
    };
    const lowerType = furnishType.toLowerCase().trim();
    return furnishingMap[lowerType] || furnishType.replace(/-/g, ' ');
  };

  // Function to get the appropriate icon component based on amenity type
  const getAmenityIcon = (amenityType) => {
    const amenityIconMap = {
      'Lift': ElevatorIcon,
      'Parking': LocalParkingIcon,
      'Gym': FitnessCenterIcon,
      'Swimming Pool': PoolIcon,
      'Pet Allowed': PetsIcon,
      'AC': AcUnitIcon,
      'TV': TvIcon,
      'Sofa': ChairIcon,
      'Fridge': KitchenIcon,
      'Furnished': WeekendIcon,
      'Internet': WifiIcon,
      'Washing Machine': LocalLaundryServiceIcon,
      'Microwave': MicrowaveIcon,
      'Power Backup': PowerIcon,
      'Security': SecurityIcon,
      'Sports': SportsBaseballIcon,
      'Children Area': ChildCareIcon,
      'Club House': HouseIcon,
      'Garden': ParkIcon,
      'Modular Kitchen': KitchenIcon,
      'BHK': BedIcon,
      'Floor': ApartmentIcon,
      'Size': SquareFootIcon,
      'Bathroom': BathtubIcon,
      'Facilities Distance': LocationOnIcon
    };
    const IconComponent = amenityIconMap[amenityType] || SquareFootIcon;
    return <IconComponent sx={{ color: '#666', fontSize: 24 }} />;
  };

  // Function to handle base64 images and videos
  const processMedia = (propertyData) => {
    const media = [];
    if (propertyData.images && Array.isArray(propertyData.images)) {
      propertyData.images.forEach((img, index) => {
        if (img.image) {
          const dataUrl = `data:image/jpeg;base64,${img.image}`;
          media.push({
            type: 'image',
            src: dataUrl,
            name: `property-image-${index + 1}`,
            thumbnail: dataUrl
          });
        }
        if (img.video_name) {
          media.push({
            type: 'video',
            src: `https://propertydealstalk.com/uploads/videos/${img.video_name}`,
            name: img.video_name,
            thumbnail: youtubeIcon
          });
        }
      });
    }
    return media;
  };

  // ✅ NEW: Function to fetch admin details when property is added by admin
  const fetchAdminDetails = async (adminId) => {
    try {
      console.log('🔍 Fetching admin details for admin_id:', adminId);
      const response = await fetch(`https://propertydealstalk.com/api/admin/getAdmin?admin_id=${adminId}`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch admin details');
      }

      const data = await response.json();
      console.log('📦 Admin API Response:', data);

      if (data.statusCode === 200 && data.result) {
        const adminData = Array.isArray(data.result) ? data.result[0] : data.result;
        setSellerDetails({
          full_name: adminData.full_name || 'Admin',
          contact_number: adminData.contact_number || adminData.phone || 'N/A',
          email_id: adminData.email_id || adminData.email || 'N/A',
          profile_image: adminData.profile_image || avatarIcon,
          role: 'admin'
        });
        console.log('✅ Admin details set successfully:', adminData);
      }
    } catch (err) {
      console.error('❌ Error fetching admin details:', err);
      // Set fallback data
      setSellerDetails({
        full_name: 'Property Owner',
        contact_number: '+91 XXXXXXXXXX',
        email_id: 'contact@propertydealstalk.com',
        profile_image: avatarIcon,
        role: 'unknown'
      });
    }
  };

  // Fetch property details when component mounts or propertyId changes
  useEffect(() => {
    setLoading(true);
    setError(null);
    setProperty(null);
    setPropertyMedia([]);
    setSelectedMediaIndex(0);
    setSellerDetails(null);

    const fetchPropertyDetails = async () => {
      try {
        const apiUrl = propertyId
          ? `https://propertydealstalk.com/api/property/getProperties?property_id=${propertyId}`
          : 'https://propertydealstalk.com/api/property/getProperties';

        console.log('🌐 Fetching property from:', apiUrl);
        const response = await fetch(apiUrl);

        if (!response.ok) {
          throw new Error('Failed to fetch property details');
        }

        const data = await response.json();
        console.log('📦 Property API Response:', data);

        if (data.statusCode === 200) {
          const propertyList = Array.isArray(data.result) ? data.result : [data.result];
          let selectedProperty;

          if (propertyId) {
            selectedProperty = Array.isArray(propertyList)
              ? propertyList.find(p => p && p.id === parseInt(propertyId))
              : propertyList;

            if (!selectedProperty && propertyList.length > 0) {
              selectedProperty = propertyList[0];
            }
          } else if (propertyList.length > 0) {
            selectedProperty = propertyList[0];
          }

          if (selectedProperty) {
            console.log('=== PROPERTY DETAILS ===');
            console.log('Property:', selectedProperty);
            console.log('Seller from API:', selectedProperty.seller);
            console.log('Added by Admin:', selectedProperty.added_by_admin);
            console.log('Admin ID:', selectedProperty.admin_id);
            console.log('Seller ID:', selectedProperty.seller_id);
            
            setProperty(selectedProperty);
            const processedMedia = processMedia(selectedProperty);
            setPropertyMedia(processedMedia);

            setInquiryDialog(prev => ({
              ...prev,
              propertyId: selectedProperty.id,
              propertyTitle: selectedProperty.property_name
            }));

            // ✅ CRITICAL FIX: Handle seller details based on who added the property
            if (selectedProperty.seller && selectedProperty.seller.full_name) {
              // If seller data exists in response, use it
              console.log('✅ Using seller data from API response');
              setSellerDetails(selectedProperty.seller);
            } else if (selectedProperty.added_by_admin && selectedProperty.admin_id) {
              // If added by admin, fetch admin details
              console.log('🔄 Property added by admin, fetching admin details...');
              await fetchAdminDetails(selectedProperty.admin_id);
            } else if (selectedProperty.seller_id) {
              // If there's a seller_id, try to fetch seller details
              console.log('🔄 Fetching seller details for seller_id:', selectedProperty.seller_id);
              // You can add a fetchSellerDetails function here if needed
            } else {
              console.log('⚠️ No seller or admin information available');
              setSellerDetails({
                full_name: 'Property Owner',
                contact_number: '+91 XXXXXXXXXX',
                email_id: 'contact@propertydealstalk.com',
                profile_image: avatarIcon,
                role: 'unknown'
              });
            }

            fetchSimilarProperties(selectedProperty.id);

            // ✅ Check favorite status after fetching property
            if (isLoggedIn && user?.id && !isSharedView) {
              checkFavoriteStatus(selectedProperty.id);
            }
          } else {
            throw new Error('Property not found');
          }
        } else {
          throw new Error(data.message || 'Failed to fetch property details');
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching property:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPropertyDetails();
  }, [propertyId, isLoggedIn, user?.id, isSharedView]);

  // ✅ Function to check if property is in favorites
  const checkFavoriteStatus = async (propId) => {
    if (!isLoggedIn || !user?.id) {
      setIsFavorite(false);
      return;
    }

    try {
      const response = await fetch(`https://propertydealstalk.com/api/buyer/getFavorites?buyer_id=${user.id}`);
      const data = await response.json();

      if (data.statusCode === 200 && data.result) {
        const favorites = Array.isArray(data.result) ? data.result : [];
        const isInFavorites = favorites.some(fav => fav.property_id === propId || fav.id === propId);
        setIsFavorite(isInFavorites);
      } else {
        setIsFavorite(false);
      }
    } catch (err) {
      console.error('Error checking favorite status:', err);
      setIsFavorite(false);
    }
  };

  // ✅ Function to toggle favorite status
  const toggleFavorite = async () => {
    if (!isLoggedIn) {
      navigate('/login');
      return;
    }

    try {
      const response = await fetch('https://propertydealstalk.com/api/buyer/addFavorites', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${user?.token}`
        },
        body: JSON.stringify({
          buyer_id: user?.id,
          property_id: property?.id || propertyId
        })
      });

      const data = await response.json();

      if (data.statusCode === 200) {
        setIsFavorite(true);
        setToast({
          open: true,
          message: 'Property added to favorites successfully',
          severity: 'success'
        });
      } else {
        throw new Error(data.message || 'Failed to add property to favorites');
      }
    } catch (err) {
      console.error('Error toggling favorite:', err);
      setToast({
        open: true,
        message: err.message || 'Failed to update favorites',
        severity: 'error'
      });
    }
  };

  // ✅ Function to handle share button click
  const handleShareClick = () => {
    const publicUrl = `${window.location.origin}/view/${property?.id || propertyId}?shared=true`;
    setShareUrl(publicUrl);
    setShareDialog(true);
  };

  // ✅ Function to copy URL to clipboard
  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setToast({
        open: true,
        message: 'URL copied to clipboard!',
        severity: 'success'
      });
    } catch (err) {
      console.error('Failed to copy URL:', err);
      setToast({
        open: true,
        message: 'Failed to copy URL',
        severity: 'error'
      });
    }
  };

  // ✅ Function to close share dialog
  const handleCloseShareDialog = () => {
    setShareDialog(false);
  };

  // Function to close toast notification
  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setToast(prev => ({ ...prev, open: false }));
  };

  // Function to fetch similar properties
  const fetchSimilarProperties = async (propId) => {
    if (!propId) return;

    setLoadingSimilar(true);
    try {
      const response = await fetch(`https://propertydealstalk.com/api/property/getSimilarProperties?property_id=${propId}`);

      if (!response.ok) {
        throw new Error('Failed to fetch similar properties');
      }

      const data = await response.json();

      if (data.statusCode === 200 && data.result && data.result.similar_properties) {
        setSimilarProperties(data.result.similar_properties.slice(0, 5));
      } else {
        console.warn('No similar properties found or invalid response format');
        setSimilarProperties([]);
      }
    } catch (err) {
      console.error('Error fetching similar properties:', err);
      setSimilarProperties([]);
    } finally {
      setLoadingSimilar(false);
    }
  };

  // Function to handle similar property click
  const handleSimilarPropertyClick = (propertyId) => {
    const sharedParam = isSharedView ? '?shared=true' : '';
    window.history.pushState({}, '', `/view/${propertyId}${sharedParam}`);

    setLoading(true);
    setError(null);
    setProperty(null);
    setPropertyMedia([]);
    setSelectedMediaIndex(0);
    setSimilarProperties([]);
    setSellerDetails(null);

    const fetchPropertyDetails = async () => {
      try {
        const apiUrl = `https://propertydealstalk.com/api/property/getProperties?property_id=${propertyId}`;
        const response = await fetch(apiUrl);

        if (!response.ok) {
          throw new Error('Failed to fetch property details');
        }

        const data = await response.json();

        if (data.statusCode === 200) {
          const propertyList = Array.isArray(data.result) ? data.result : [data.result];
          let selectedProperty;

          selectedProperty = Array.isArray(propertyList)
            ? propertyList.find(p => p && p.id === parseInt(propertyId))
            : propertyList;

          if (!selectedProperty && propertyList.length > 0) {
            selectedProperty = propertyList[0];
          }

          if (selectedProperty) {
            setProperty(selectedProperty);
            const processedMedia = processMedia(selectedProperty);
            setPropertyMedia(processedMedia);

            setInquiryDialog(prev => ({
              ...prev,
              propertyId: selectedProperty.id,
              propertyTitle: selectedProperty.property_name
            }));

            // Handle seller details
            if (selectedProperty.seller && selectedProperty.seller.full_name) {
              setSellerDetails(selectedProperty.seller);
            } else if (selectedProperty.added_by_admin && selectedProperty.admin_id) {
              await fetchAdminDetails(selectedProperty.admin_id);
            }

            fetchSimilarProperties(selectedProperty.id);

            if (isLoggedIn && !isSharedView) {
              checkFavoriteStatus(selectedProperty.id);
            }
          } else {
            throw new Error('Property not found');
          }
        } else {
          throw new Error(data.message || 'Failed to fetch property details');
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching property:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPropertyDetails();
    window.scrollTo(0, 0);
  };

  // Function to handle opening the inquiry dialog
  const handleOpenInquiry = () => {
    if (!isLoggedIn) {
      navigate('/login');
      return;
    }

    setInquiryDialog(prev => ({
      ...prev,
      open: true
    }));
  };

  // Function to handle closing the inquiry dialog
  const handleCloseInquiry = () => {
    setInquiryDialog(prev => ({
      ...prev,
      open: false
    }));
  };

  // Function to handle media selection
  const handleMediaSelect = (index) => {
    setSelectedMediaIndex(index);
  };

  // Function to open modal with selected media
  const handleOpenModal = (index) => {
    setSelectedMediaIndex(index);
    setModalOpen(true);
  };

  // Function to close modal
  const handleCloseModal = () => {
    setModalOpen(false);
  };

  // Function to navigate media in modal
  const handleModalNavigation = (direction) => {
    if (direction === 'next') {
      setSelectedMediaIndex((prev) => (prev + 1) % propertyMedia.length);
    } else {
      setSelectedMediaIndex((prev) => (prev - 1 + propertyMedia.length) % propertyMedia.length);
    }
  };

  // Function to format price with commas
  const formatPrice = (price) => {
    return price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || '';
  };

  // Parse amenities from property data
  const parseAmenities = (property) => {
    if (!property) return [];

    const amenitiesList = [];

    if (property.society_aminities) {
      const societyAmenities = property.society_aminities.split(',').map(item => item.trim());
      amenitiesList.push(...societyAmenities);
    }

    if (property.furnish_facilities) {
      const furnishFacilities = property.furnish_facilities.split(',').map(item => item.trim());
      amenitiesList.push(...furnishFacilities);
    }

    if (property.other_facilities) {
      const otherFacilities = property.other_facilities.split(',').map(item => item.trim());
      amenitiesList.push(...otherFacilities);
    }

    return [...new Set(amenitiesList)];
  };

  // If still loading, show loading spinner
  if (loading || !property) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // ✅ Get all amenities
  const allAmenities = parseAmenities(property);

  // ✅ Function to determine if amenities should be shown based on property type
  const shouldShowAmenities = () => {
    const residentialTypes = ['Apartment', 'House', 'Villa', 'Residential'];
    return residentialTypes.some(type =>
      property.asset_type?.includes(type) || property.property_type?.includes(type)
    );
  };

  // Calculate built year from age_of_property
  const builtYear = property.age_of_property
    ? (new Date().getFullYear() - property.age_of_property)
    : 'Not specified';

  // ✅ Get property details for the top section
  const getPropertyDetails = () => {
    const details = [];

    if (hasValue(property.bhk)) {
      details.push({ type: 'BHK', value: `${property.bhk} BHK` });
    }

    if (hasValue(property.select_floor) && hasValue(property.total_floors)) {
      details.push({ type: 'Floor', value: `${property.select_floor}/${property.total_floors} Floor` });
    }

    if (hasValue(property.property_size)) {
      const sizeUnit = hasValue(property.property_size_units) ? property.property_size_units : 'sq.ft';
      details.push({ type: 'Size', value: `${property.property_size} ${sizeUnit}` });
    }

    return details;
  };

  const propertyDetails = getPropertyDetails();

  // ✅ Determine the price to display
  const getDisplayPrice = () => {
    const category = property.category || property.commercial_catgory || '';
    const isRental = category.toLowerCase() === 'rent';

    if (isRental) {
      if (hasValue(property.monthly_rent) && property.monthly_rent !== 0) {
        return property.monthly_rent;
      }
    }

    if (hasValue(property.asking_price) && property.asking_price !== 0) {
      return property.asking_price;
    }

    return null;
  };

  const displayPrice = getDisplayPrice();
  const isRentalProperty = (property.category || property.commercial_catgory || '').toLowerCase() === 'rent';

  // ✅ Determine if contact info should be shown
  const shouldShowContactInfo = isLoggedIn && !isSharedView;

  // ✅ ULTIMATE FIX: Get seller details from state with fallbacks
  const sellerName = shouldShowContactInfo 
    ? (sellerDetails?.full_name || "Property Owner")
    : "Seller";
  
  const sellerContact = shouldShowContactInfo 
    ? (sellerDetails?.contact_number || "+91 XXXXXXXXXX")
    : '+91 123*****89';
  
  const sellerEmail = shouldShowContactInfo 
    ? (sellerDetails?.email_id || "seller@example.com")
    : 'Seller*****@gmail.com';
  
  const sellerImage = sellerDetails?.profile_image || avatarIcon;

  console.log('=== RENDER TIME VALUES ===');
  console.log('Should Show Contact Info:', shouldShowContactInfo);
  console.log('Seller Details State:', sellerDetails);
  console.log('Seller Name:', sellerName);
  console.log('Seller Contact:', sellerContact);
  console.log('Seller Email:', sellerEmail);

  return (
    <Box
      sx={{
        background: '#f9f9f9',
        fontFamily: 'Outfit, sans-serif',
        px: isMobile ? 2 : 6,
        py: isMobile ? 2 : 4,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? 3 : 4,
        }}
      >
        {/* LEFT SECTION */}
        <Box sx={{ flex: 1 }}>
          {/* Main Media Display */}
          <Box sx={{ position: 'relative', width: '100%', height: isMobile ? 250 : 450 }}>
            {propertyMedia.length > 0 ? (
              <>
                {propertyMedia[selectedMediaIndex].type === 'image' ? (
                  <Box
                    component="img"
                    src={propertyMedia[selectedMediaIndex].src}
                    alt={property.property_name}
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: 2,
                      cursor: 'pointer'
                    }}
                    onClick={() => handleOpenModal(selectedMediaIndex)}
                  />
                ) : (
                  <Box
                    sx={{
                      width: '100%',
                      height: '100%',
                      bgcolor: '#000',
                      borderRadius: 2,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      position: 'relative'
                    }}
                    onClick={() => handleOpenModal(selectedMediaIndex)}
                  >
                    <video
                      src={propertyMedia[selectedMediaIndex].src}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: 2
                      }}
                    />
                    <PlayArrowIcon
                      sx={{
                        position: 'absolute',
                        color: 'white',
                        fontSize: 60,
                        opacity: 0.8
                      }}
                    />
                  </Box>
                )}
              </>
            ) : (
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#f5f5f5',
                  borderRadius: 2,
                  border: '1px dashed #ccc'
                }}
              >
                <Typography variant="h6" color="#888" textAlign="center">
                  No images uploaded
                </Typography>
              </Box>
            )}
                        {/* Media counter */}
            {propertyMedia.length > 1 && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 16,
                  right: 16,
                  bgcolor: 'rgba(0,0,0,0.7)',
                  color: 'white',
                  padding: '4px 12px',
                  borderRadius: 2,
                  fontSize: 14
                }}
              >
                {selectedMediaIndex + 1} / {propertyMedia.length}
              </Box>
            )}

            {/* Navigation arrows for media */}
            {propertyMedia.length > 1 && (
              <>
                <IconButton
                  sx={{
                    position: 'absolute',
                    left: 16,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    bgcolor: 'rgba(255,255,255,0.9)',
                    '&:hover': { bgcolor: 'rgba(255,255,255,1)' }
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleMediaSelect((selectedMediaIndex - 1 + propertyMedia.length) % propertyMedia.length);
                  }}
                >
                  <Typography variant="h6" sx={{ color: '#000' }}>‹</Typography>
                </IconButton>
                <IconButton
                  sx={{
                    position: 'absolute',
                    right: 16,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    bgcolor: 'rgba(255,255,255,0.9)',
                    '&:hover': { bgcolor: 'rgba(255,255,255,1)' }
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleMediaSelect((selectedMediaIndex + 1) % propertyMedia.length);
                  }}
                >
                  <Typography variant="h6" sx={{ color: '#000' }}>›</Typography>
                </IconButton>
              </>
            )}
          </Box>

          {/* Media Thumbnails Gallery */}
          {propertyMedia.length > 1 && (
            <Box
              sx={{
                display: 'flex',
                gap: 2,
                mt: 2,
                overflowX: 'auto',
                pb: 1,
                '&::-webkit-scrollbar': {
                  height: 4,
                },
                '&::-webkit-scrollbar-track': {
                  background: '#f1f1f1',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#888',
                  borderRadius: 2,
                },
              }}
            >
              {propertyMedia.map((media, index) => (
                <Box
                  key={index}
                  sx={{
                    position: 'relative',
                    minWidth: 80,
                    height: 80,
                    borderRadius: 2,
                    overflow: 'hidden',
                    cursor: 'pointer',
                    border: selectedMediaIndex === index ? '3px solid #2563EB' : '2px solid #ddd',
                    opacity: selectedMediaIndex === index ? 1 : 0.7,
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      opacity: 1,
                      transform: 'scale(1.05)'
                    }
                  }}
                  onClick={() => handleMediaSelect(index)}
                >
                  {media.type === 'image' ? (
                    <Box
                      component="img"
                      src={media.src}
                      alt={`Thumbnail ${index + 1}`}
                      sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  ) : (
                    <Box
                      sx={{
                        width: '100%',
                        height: '100%',
                        bgcolor: '#000',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <PlayArrowIcon sx={{ color: 'white', fontSize: 24 }} />
                    </Box>
                  )}
                  {media.type === 'video' && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 4,
                        right: 4,
                        bgcolor: 'rgba(0,0,0,0.7)',
                        borderRadius: '50%',
                        width: 20,
                        height: 20,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <PlayArrowIcon sx={{ color: 'white', fontSize: 12 }} />
                    </Box>
                  )}
                </Box>
              ))}
            </Box>
          )}

          {/* Description Box */}
          <Box mt={4} bgcolor="#fff" p={3} borderRadius={2}>
            {/* ✅ Property Description - Show only if it has value */}
            {hasValue(property.description) && (
              <>
                <Typography variant="h6" mb={2}>Property Description</Typography>
                <Typography fontSize={14} color="#626262" mb={2}>
                  {property.description}
                </Typography>
              </>
            )}

            {/* ✅ Content Section - Show only if it has value (for commercial plots) */}
            {hasValue(property.content) && (
              <>
                <Typography variant="h6" mb={2} mt={hasValue(property.description) ? 3 : 0}>
                  Additional Content
                </Typography>
                <Typography fontSize={14} color="#626262" mb={2}>
                  {property.content}
                </Typography>
              </>
            )}

            {/* ✅ Complete Address - Show only if it has value */}
            {hasValue(property.full_address) && (
              <>
                <Typography variant="h6" mb={2} mt={3}>Complete Address</Typography>
                <Typography fontSize={14} color="#626262" mb={2}>
                  {property.full_address}
                </Typography>
              </>
            )}

            {/* ✅ Features & Amenities - Only show for applicable property types */}
            {shouldShowAmenities() && allAmenities.length > 0 && (
              <>
                <Typography variant="subtitle1" mb={2} mt={3} fontWeight={500}>
                  Features & Amenities
                </Typography>
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                    columnGap: 4,
                    rowGap: 2,
                  }}
                >
                  {allAmenities.map((amenity, index) => (
                    <Box key={index} display="flex" alignItems="center" gap={1} fontSize={14} fontWeight="bold">
                      {getAmenityIcon(amenity)}
                      {amenity}
                    </Box>
                  ))}
                </Box>
              </>
            )}

            {/* ✅ Carpet Area & Built-up Area - Only for Apartments */}
            {property.asset_type === 'Apartment' && (hasValue(property.carpet_area) || hasValue(property.built_up_area) || hasValue(property.uds)) && (
              <>
                <Typography variant="subtitle1" mt={3} mb={2} fontWeight={500}>
                  Area Details
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: 2,
                  }}
                >
                  {hasValue(property.carpet_area) && (
                    <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262" flex={1}>
                      <Box minWidth={130}>Carpet Area</Box>
                      <Box fontWeight="bold">
                        {property.carpet_area} {property.carpet_area_units}
                      </Box>
                    </Box>
                  )}
                  {hasValue(property.built_up_area) && (
                    <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262" flex={1}>
                      <Box minWidth={130}>Built-up Area</Box>
                      <Box fontWeight="bold">
                        {property.built_up_area} {property.built_up_area_units}
                      </Box>
                    </Box>
                  )}
                </Box>
                {/* ✅ UDS Field */}
                {hasValue(property.uds) && (
                  <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262" mt={1}>
                    <Box minWidth={130}>UDS (Undivided Share)</Box>
                    <Box fontWeight="bold">
                      {property.uds} {property.uds_units || 'Sq.Ft'}
                    </Box>
                  </Box>
                )}
              </>
            )}

            {/* ✅ Additional Details Section */}
            <Typography variant="subtitle1" mt={3} fontWeight={500}>Additional Details</Typography>
            <Box mt={1}>
              {/* Property Type - Always show */}
              <Box
                display="flex"
                flexWrap="wrap"
                alignItems="center"
                gap={isMobile ? 1 : 3}
                mb={1}
                fontSize={14}
                color="#626262"
                fontWeight={400}
              >
                <Box minWidth={130}>Property Type</Box>
                <Box fontWeight="bold">{property.property_type} {property.asset_type}</Box>
              </Box>

              {/* Property ID - Always show */}
              <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
                <Box minWidth={130}>Property ID</Box>
                <Box fontWeight="bold">#{property.id}</Box>
              </Box>

              {/* ✅ Price Negotiable */}
              {hasValue(property.negotiable) && (
                <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
                  <Box minWidth={130}>Price Negotiable</Box>
                  <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
                    {property.negotiable === 'true' || property.negotiable === true ? 'Yes' : 'No'}
                  </Box>
                </Box>
              )}

              {/* ✅ Total Floors */}
              {hasValue(property.total_floors) && (
                <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
                  <Box minWidth={130}>Total Floors</Box>
                  <Box fontWeight="bold">{property.total_floors}</Box>
                </Box>
              )}

              {/* ✅ Floor Number */}
              {hasValue(property.select_floor) && (
                <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
                  <Box minWidth={130}>Floor Number</Box>
                  <Box fontWeight="bold">{property.select_floor}</Box>
                </Box>
              )}

              {/* ✅ Furnishing */}
              {hasValue(property.furnish_type) && (
                <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
                  <Box minWidth={130}>Furnishing</Box>
                  <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
                    {getFurnishingTypeName(property.furnish_type)}
                  </Box>
                </Box>
              )}

              {/* ✅ Construction Status */}
              {hasValue(property.construction_status) && (
                <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
                  <Box minWidth={130}>Construction Status</Box>
                  <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
                    {property.construction_status}
                  </Box>
                </Box>
              )}

              {/* ✅ Monthly Rent */}
              {hasValue(property.monthly_rent) && (
                <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
                  <Box minWidth={130}>Monthly Rent</Box>
                  <Box fontWeight="bold">
                    {property.currency}{formatPrice(property.monthly_rent)}
                  </Box>
                </Box>
              )}

              {/* ✅ Security Deposit */}
              {hasValue(property.security_deposit) && (
                <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
                  <Box minWidth={130}>Security Deposit</Box>
                  <Box fontWeight="bold">{property.security_deposit}</Box>
                </Box>
              )}

              {/* ✅ Available From */}
              {hasValue(property.available_from) && (
                <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
                  <Box minWidth={130}>Available From</Box>
                  <Box fontWeight="bold">
                    {new Date(property.available_from).toLocaleDateString('en-US', {
                      month: 'long',
                      day: 'numeric',
                      year: 'numeric'
                    })}
                  </Box>
                </Box>
              )}

              {/* ✅ Length */}
              {hasValue(property.length) && (
                <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
                  <Box minWidth={130}>Length</Box>
                  <Box fontWeight="bold">
                    {property.length} {property.property_size_units}
                  </Box>
                </Box>
              )}

              {/* ✅ Width */}
              {hasValue(property.width) && (
                <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
                  <Box minWidth={130}>Width</Box>
                  <Box fontWeight="bold">
                    {property.width} {property.property_size_units}
                  </Box>
                </Box>
              )}

              {/* ✅ Ownership */}
              {hasValue(property.ownership) && (
                <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
                  <Box minWidth={130}>Ownership</Box>
                  <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
                    {property.ownership}
                  </Box>
                </Box>
              )}

              {/* ✅ Hub */}
              {hasValue(property.hub) && (
                <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
                  <Box minWidth={130}>Hub</Box>
                  <Box fontWeight="bold">{property.hub}</Box>
                </Box>
              )}

              {/* ✅ Commercial Category */}
              {hasValue(property.commercial_catgory) && (
                <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
                  <Box minWidth={130}>Category</Box>
                  <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
                    {property.commercial_catgory}
                  </Box>
                </Box>
              )}

              {/* ✅ YouTube Link */}
              {hasValue(property.youtube_link) && property.youtube_link !== "null" && (
                <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
                  <Box minWidth={130}>YouTube Link</Box>
                  <Box fontWeight="bold" sx={{ wordBreak: 'break-all' }}>
                    {shouldShowContactInfo ? (
                      <a
                        href={property.youtube_link.trim()}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: '#2563EB',
                          textDecoration: 'underline',
                          cursor: 'pointer'
                        }}
                      >
                        {property.youtube_link.trim()}
                      </a>
                    ) : (
                      <span style={{ color: '#2563EB' }}>https://youtu.be/****</span>
                    )}
                  </Box>
                </Box>
              )}

              {/* ✅ Property Video */}
              {propertyMedia.some(media => media.type === 'video') && (
                <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
                  <Box minWidth={130}>Property Video</Box>
                  <Box fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <img src={youtubeIcon} alt="Video" width={18} />
                    Available
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Box>

        {/* RIGHT SECTION */}
        <Box sx={{ flex: 1, maxWidth: isMobile ? '100%' : 420 }}>
          <Box
            bgcolor="#fff"
            p={3}
            borderRadius={2}
            mb={3}
            height={isMobile ? 'auto' : 'auto'}
            display="flex"
            flexDirection="column"
          >
            {/* ✅ Display price */}
            <Typography color="#2563EB" fontstyle="semibold" fontSize={22} fontWeight={600}>
              {displayPrice && displayPrice !== 0 ? (
                <>
                  {property.currency || '₹'}{formatPrice(displayPrice)}
                  {isRentalProperty && ' /month'}
                </>
              ) : (
                'Price on Request'
              )}
            </Typography>

            <Typography fontSize={17} my={1.5} fontWeight={600}>
              {property.property_name}
            </Typography>

            <Box display="flex" alignItems="center" gap={1} fontSize={14} fontWeight={400} color="#555" mb={1}>
              <LocationOnIcon sx={{ fontSize: 16, color: '#666' }} />
              {property.location}, {property.area_name}
            </Box>

            <Box display="flex" justifyContent="space-between" my={1} fontWeight={400} fontSize={13.5} color="#666">
              <Box display="flex" alignItems="center" gap={1}>
                <img src={calendarIcon} alt="Calendar" width={16} height={17} />
                {new Date(property.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
              </Box>
            </Box>

            {/* ✅ Property Details with Icons */}
            {propertyDetails.length > 0 && (
              <Box display="flex" gap={isMobile ? 4 : 8} flexWrap="wrap" my={2} justifyContent="space-between">
                {propertyDetails.map((detail, index) => (
                  <Box key={index} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Box sx={{ color: '#666', fontSize: 30, height: 40, display: 'flex', alignItems: 'center' }}>
                      {getAmenityIcon(detail.type)}
                    </Box>
                    <Typography fontSize={14}>{detail.value}</Typography>
                  </Box>
                ))}
              </Box>
            )}

            <hr style={{ margin: '8px 0', border: 'none', borderTop: '1px solid #eee' }} />

            {/* ✅ ULTIMATE FIX: Contact Seller Section with Admin Details */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Typography variant="subtitle1" fontSize={17} fontWeight={600} color="#000000">
                Contact Seller
              </Typography>
              {shouldShowContactInfo && (
                <Button
                  variant="text"
                  sx={{ p: 0, minWidth: 'auto' }}
                  onClick={handleOpenInquiry}
                >
                  <img src={contactim} alt="Contact" style={{ height: 40 }} />
                </Button>
              )}
            </Box>

            <Box display="flex" alignItems="center" gap={3} mt={1}>
              <Avatar
                src={sellerImage}
                sx={{ width: 57, height: 62 }}
              />
              <Box>
                {/* ✅ CRITICAL FIX: Display seller/admin details from state */}
                <Typography fontSize={15} fontWeight={500} color="#000000">
                  {sellerName}
                </Typography>
                <Typography fontSize={13} color="blue" fontWeight={400}>
                  {sellerContact}
                </Typography>
                <Typography fontSize={15} color="#000000" fontWeight={500}>
                  {sellerEmail}
                </Typography>
              </Box>
            </Box>

            <hr style={{ margin: '12px 0', border: 'none', borderTop: '1px solid #eee' }} />

            {/* ✅ Save and Share buttons */}
            {shouldShowContactInfo && (
              <Box display="flex" gap={3} mt={2} alignItems="center">
                {/* Save Button */}
                <Box
                  display="flex"
                  alignItems="center"
                  gap={1}
                  sx={{ cursor: 'pointer' }}
                  onClick={toggleFavorite}
                >
                  {isFavorite ? (
                    <FavoriteIcon sx={{ color: 'red', fontSize: 32 }} />
                  ) : (
                    <FavoriteBorderIcon sx={{ color: '#666', fontSize: 32 }} />
                  )}
                  <Typography fontSize={14} fontWeight={500} color="#000">
                    Save
                  </Typography>
                </Box>

                {/* Share Button */}
                <Box
                  display="flex"
                  alignItems="center"
                  gap={1}
                  sx={{ cursor: 'pointer' }}
                  onClick={handleShareClick}
                >
                  <ShareIcon sx={{ color: '#666', fontSize: 28 }} />
                  <Typography fontSize={14} fontWeight={500} color="#000">
                    Share
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>

          {/* Similar Properties */}
          <Box bgcolor="#fff" p={3} borderRadius={2}>
            <Typography variant="subtitle1" mb={2} fontWeight={600}>
              Similar Properties
            </Typography>
            {loadingSimilar ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                <CircularProgress size={24} />
              </Box>
            ) : similarProperties.length === 0 ? (
              <Typography color="#666">No similar properties found.</Typography>
            ) : (
              similarProperties.map((sim) => {
                const simImageSrc = sim.image
                  ? `data:image/png;base64,${sim.image}`
                  : similarImg;

                return (
                  <Box
                    key={sim.id}
                    display="flex"
                    alignItems="center"
                    gap={2}
                    mb={2}
                    sx={{
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        backgroundColor: '#f5f8ff',
                        borderRadius: '8px'
                      },
                      p: 1
                    }}
                    onClick={() => handleSimilarPropertyClick(sim.id)}
                  >
                    <img
                      src={simImageSrc}
                      alt={sim.property_name || 'Similar Property'}
                      width={60}
                      height={60}
                      style={{ borderRadius: 8, objectFit: 'cover' }}
                    />
                    <Box>
                      <Typography fontSize={13} fontWeight={500}>
                        {sim.property_name || `${sim.asset_type || ''} ${sim.property_type || ''}`}
                      </Typography>
                      <Typography fontSize={13} color="#2563EB" fontWeight={500}>
                        {sim.currency || '₹'}
                        {formatPrice(sim.asking_price)}
                      </Typography>
                      <Typography fontSize={12} color="#666">
                        {sim.area_name ? `${sim.area_name}, ${sim.location}` : `${sim.location}`}
                      </Typography>
                    </Box>
                  </Box>
                );
              })
            )}
          </Box>
        </Box>
      </Box>

      {/* Media Modal */}
      <Modal
        open={modalOpen}
        onClose={handleCloseModal}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backdropFilter: 'blur(5px)'
        }}
      >
        <Box sx={{ position: 'relative', maxWidth: '90vw', maxHeight: '90vh' }}>
          <IconButton
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              bgcolor: 'rgba(0,0,0,0.5)',
              color: 'white',
              zIndex: 1000,
              '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
            }}
            onClick={handleCloseModal}
          >
            <CloseIcon />
          </IconButton>

          {propertyMedia.length > 1 && (
            <>
              <IconButton
                sx={{
                  position: 'absolute',
                  left: 8,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  bgcolor: 'rgba(0,0,0,0.5)',
                  color: 'white',
                  zIndex: 1000,
                  '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
                }}
                onClick={() => handleModalNavigation('prev')}
              >
                <Typography variant="h6">‹</Typography>
              </IconButton>
              <IconButton
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  bgcolor: 'rgba(0,0,0,0.5)',
                  color: 'white',
                  zIndex: 1000,
                  '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
                }}
                onClick={() => handleModalNavigation('next')}
              >
                <Typography variant="h6">›</Typography>
              </IconButton>
            </>
          )}

          {propertyMedia[selectedMediaIndex]?.type === 'image' ? (
            <Box
              component="img"
              src={propertyMedia[selectedMediaIndex].src}
              alt={property.property_name}
              sx={{
                maxWidth: '100%',
                maxHeight: '90vh',
                objectFit: 'contain'
              }}
            />
          ) : (
            <Box
              sx={{
                width: '80vw',
                height: '80vh',
                bgcolor: '#000'
              }}
            >
              <video
                src={propertyMedia[selectedMediaIndex]?.src}
                controls
                autoPlay
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain'
                }}
              />
            </Box>
          )}
        </Box>
      </Modal>

      {/* ✅ Share Dialog */}
      <Dialog
        open={shareDialog}
        onClose={handleCloseShareDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" fontWeight={600}>Share Property</Typography>
          <IconButton onClick={handleCloseShareDialog} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="#666" mb={2}>
            Share this property link with others. Anyone with this link can view the property details.
          </Typography>
          <TextField
            fullWidth
            value={shareUrl}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleCopyUrl}
                    edge="end"
                    color="primary"
                    title="Copy URL"
                  >
                    <ContentCopyIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            variant="outlined"
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#f5f5f5',
              }
            }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleCloseShareDialog} variant="outlined">
            Close
          </Button>
          <Button onClick={handleCopyUrl} variant="contained" startIcon={<ContentCopyIcon />}>
            Copy Link
          </Button>
        </DialogActions>
      </Dialog>

      {/* Toast Notification */}
      <Snackbar
        open={toast.open}
        autoHideDuration={6000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseToast} severity={toast.severity} sx={{ width: '100%' }}>
          {toast.message}
        </Alert>
      </Snackbar>

      {/* Inquiry Dialog */}
      <CreateInquiry
        open={inquiryDialog.open}
        onClose={handleCloseInquiry}
        propertyId={inquiryDialog.propertyId}
        buyerId={user?.id || 1}
        propertyTitle={inquiryDialog.propertyTitle}
      />
    </Box>
  );
};

export default TalkView;